var _defs, _rect, _g, _rect2, _rect3, _path, _rect4, _path2, _rect5, _g2, _rect6, _rect7, _path3, _rect8, _path4, _g3, _g4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChangesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.169,
    height: 142.962,
    viewBox: "0 0 150.169 142.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b,.l,.m,.n,.o{opacity:0.5;}.c{fill:url(#a);}.d{fill:#fafafa;}.e{fill:url(#b);}.f{fill:url(#c);}.g{fill:#009de0;}.h{fill:url(#d);}.i{fill:#fff;}.j{fill:url(#f);}.k,.o{fill:#47e6b1;}.l{fill:#4d8af0;}.m{fill:#fdd835;}.n{fill:#f55f44;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.509,
    y1: 0.997,
    x2: 0.509,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.813,
    y1: 0.841,
    x2: 0.813,
    y2: -0.159,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.78,
    y1: 0.849,
    x2: 1.78,
    y2: -0.151,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80.017,
    height: 110.557,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 12.642, 24.803)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(14.371 10.133)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 77.312,
    height: 106.82,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 0, 16.219)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 75.344,
    height: 104.46,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 15.483, 26.909)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 37.377,
    height: 9.054,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 33.191, 18.477)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M442.6,91.388a5.35,5.35,0,1,0,6.225,4.134A5.288,5.288,0,0,0,442.6,91.388Zm1.771,8.258a3.087,3.087,0,1,1,2.3-3.662,3.05,3.05,0,0,1-2.3,3.662Z",
    transform: "translate(-392.976 -85.473)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 36.59,
    height: 8.655,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 33.494, 18.016)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M442.9,91.387a5.114,5.114,0,1,0,6.073,3.927,5.114,5.114,0,0,0-6.073-3.927Zm1.692,7.891a2.952,2.952,0,1,1,2.267-3.5,2.952,2.952,0,0,1-2.267,3.5Z",
    transform: "translate(-393.276 -85.471)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80.017,
    height: 110.557,
    transform: "translate(47.219 21.406)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(48.572 23.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 77.312,
    height: 106.82
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 75.344,
    height: 104.46,
    transform: "translate(49.555 24.063)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 37.377,
    height: 9.054,
    transform: "translate(68.637 19.533)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M643.546,118a5.352,5.352,0,1,0,5.226,5.35A5.289,5.289,0,0,0,643.546,118Zm0,8.437a3.087,3.087,0,1,1,3.014-3.087,3.05,3.05,0,0,1-3.014,3.072Z",
    transform: "translate(-556.22 -107.305)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 36.59,
    height: 8.655,
    transform: "translate(69.031 19.145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M644.044,118a5.114,5.114,0,1,0,5.114,5.114A5.114,5.114,0,0,0,644.044,118Zm0,8.065a2.954,2.954,0,1,0,0-.009Z",
    transform: "translate(-556.718 -107.305)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1.188 134.951)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.688,
    height: 3.905,
    transform: "translate(1.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.688,
    height: 3.905,
    transform: "translate(3.905 1.609) rotate(90)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(81.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.688,
    height: 3.905,
    transform: "translate(1.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 0.688,
    height: 3.905,
    transform: "translate(3.905 1.608) rotate(90)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M948.412,825.183a.844.844,0,0,1-.471-1.02.406.406,0,0,0,.018-.093h0a.423.423,0,0,0-.76-.28h0a.409.409,0,0,0-.048.082.844.844,0,0,1-1.02.471.406.406,0,0,0-.093-.018h0a.423.423,0,0,0-.28.76h0a.409.409,0,0,0,.082.048.844.844,0,0,1,.471,1.02.409.409,0,0,0-.018.093h0a.423.423,0,0,0,.76.28h0a.407.407,0,0,0,.048-.082.844.844,0,0,1,1.02-.471.405.405,0,0,0,.093.018h0a.423.423,0,0,0,.28-.76h0A.413.413,0,0,0,948.412,825.183Z",
    transform: "translate(-807.23 -683.73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M314,620.123a.844.844,0,0,1-.471-1.02.406.406,0,0,0,.018-.093h0a.423.423,0,0,0-.76-.28h0a.406.406,0,0,0-.048.082.844.844,0,0,1-1.02.471.406.406,0,0,0-.093-.018h0a.423.423,0,0,0-.28.76h0a.4.4,0,0,0,.082.048.844.844,0,0,1,.471,1.02.407.407,0,0,0-.018.093h0a.423.423,0,0,0,.76.28h0a.407.407,0,0,0,.048-.082.844.844,0,0,1,1.02-.471.406.406,0,0,0,.093.018h0a.423.423,0,0,0,.28-.76h0A.406.406,0,0,0,314,620.123Z",
    transform: "translate(-288.979 -516.215)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M842.412,120.8a.844.844,0,0,1-.471-1.02.4.4,0,0,0,.018-.093h0a.423.423,0,0,0-.76-.28h0a.406.406,0,0,0-.048.082.844.844,0,0,1-1.02.471.406.406,0,0,0-.093-.018h0a.423.423,0,0,0-.28.76h0a.408.408,0,0,0,.082.048.844.844,0,0,1,.471,1.02.409.409,0,0,0-.018.093h0a.423.423,0,0,0,.76.28h0a.406.406,0,0,0,.048-.082.844.844,0,0,1,1.02-.471.407.407,0,0,0,.093.018h0a.423.423,0,0,0,.28-.76h0A.407.407,0,0,0,842.412,120.8Z",
    transform: "translate(-720.639 -108.318)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(147.412 56.199)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(40.867 135.33)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(133.254 86)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(14.576 16.262)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.379,
    cy: 1.379,
    r: 1.379,
    transform: "translate(0 53.873)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChangesIcon);
export default __webpack_public_path__ + "static/media/noChangesIcon.37143d9c97032e64324c82d614d2c53a.svg";
export { ForwardRef as ReactComponent };